import type { Menu, Reference, SiteHeader } from '@ps/web-martech-cms-types';
import { get } from 'lodash';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const exclusionItemsTitles = ['Store', 'Challenges', 'Promotions', 'PokerStars Rewards'];

const useSeoMenu = (layout?: SiteHeader['layout']) => {
  const { seoMenu, seoDepth } = useSelector(select.cms.getSEOMenu);
  const content = useSelector(select.cms.getContent);
  const isSportsSelfExcluded = useSelector(select.account.isSportsSelfExcluded);

  if (!seoMenu) {
    return { seoMenu: null, seoDepth: null, discoveryMoreMenu: null, seoMobileMenu: null };
  }

  if (isSportsSelfExcluded || layout === 'Play Money') {
    seoMenu.children = seoMenu.children?.filter((item) => {
      const menu = get(content, item?.uid || '') as Menu;
      return !exclusionItemsTitles.includes(menu.title);
    });
  }

  const { discoveryMoreChildren, seoChildren } = seoMenu.children.reduce<{
    discoveryMoreChildren: Reference[];
    seoChildren: Reference[];
  }>(
    (acc, child) => {
      const menu = get(content, child?.uid || '') as Menu;
      if (menu.show_in_discover_more) {
        acc.discoveryMoreChildren.push(child);
      } else {
        acc.seoChildren.push(child);
      }
      return acc;
    },
    { discoveryMoreChildren: [], seoChildren: [] }
  );

  return {
    seoMenu,
    seoDepth,
    discoveryMoreMenu: discoveryMoreChildren.length
      ? { ...seoMenu, children: discoveryMoreChildren }
      : null,
    seoMobileMenu: seoChildren.length ? { ...seoMenu, children: seoChildren } : null
  };
};

export default useSeoMenu;
